import { render, staticRenderFns } from "./Theme2Section4.vue?vue&type=template&id=e12988a8&scoped=true&"
import script from "./Theme2Section4.vue?vue&type=script&lang=js&"
export * from "./Theme2Section4.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Section4.vue?vue&type=style&index=0&id=e12988a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12988a8",
  null
  
)

export default component.exports